/**
 * countBytesUTF8.js
 * Talkroute
 *
 * Created by Vel Genov on 5/16/19
 * Copyright (c) 2019 Talkroute. All right reserved.
 */

/**
 * Counts the bytes in a string using UTF-8. Used with counting characters in text messages
 *
 * @param inputString the string to count characters in
 * @returns the number of characters in the string
 */
const countBytesUTF8 = (inputString: string) => {
  let characterCount = 0;
  if (inputString) {
    characterCount = Buffer.byteLength(inputString, "utf8");
  }

  return characterCount;
};

export default countBytesUTF8;
